import React, {Component} from 'react';

import axios from 'axios';
import HeaderFooterHOC from '../HOC/HeaderFooterHOC';
// translations
import LangContext from "../providers/LangContext";
import PdfViewer from "../../global-components/admin/modules/PdfViewer";

class Brochure extends Component {

    static contextType = LangContext;

	constructor(props) {
		super(props);
		this.getBrochure = this.getBrochure.bind(this);
		this.getBrochureSize = this.getBrochureSize.bind(this);

		this.state = {
			loadinglq: false,
			loadinghq: false,
			brochureHqSize: 0,
			brochureLqSize: 0,
            brochureSlug: '',
		}
	}

	componentDidMount() {
		this.getBrochureSize();
	}

	getBrochureSize() {
		axios({
			url: '/api/site/' + this.props.siteID + '/brochure-size',
			method: 'GET',
		}).then((response) => {
			this.setState({
				brochureHqSize: response.data.brochure_hq,
				brochureLqSize: response.data.brochure_lq,
                brochureSlug: response.data.brochure_name,
			});
		}).catch((error) => {

		});
	}

	getBrochure(quality) {
		let self = this;

		let filename = this.state.brochureSlug;

        this.setState(
            {loadinglq: true}
        );

		axios({
			url: '/api/site/' + this.props.siteID + '/brochure?name=' + filename,
			method: 'GET',
			responseType: 'blob', // important
		}).then((response) => {
			self.setState(
				{loadinglq: false,
						loadinghq: false}
			);
			const url = window.URL.createObjectURL(new Blob([response.data], {
				type: 'application/pdf',
			}));
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
		});

	}

	render() {
	    if(this.state.brochureSlug === '') {
	        return 'Loading...';
        }

        return (
			<div className="row">
				<div className="col-12 text-decoration-none">
                    <PdfViewer
                        pdfUrl={`/storage/sites/${this.props.siteID}/brochure/${this.state.brochureSlug}?file=${Math.floor(Math.random() * 100)}`}
                    />
				</div>
			</div>
		)
	}
}

export default HeaderFooterHOC(Brochure);
